// Work kit rollup helpers (W6 Track B) — pure module, no Stimulus side
// effects. Rollups are computed BY THE ENGINE over its currently loaded rows
// (the deliberate reconciliation with the pivot law: the pivot visual's host
// pre-computes at display grain, but the grid engine owns its rows, so
// arithmetic over injected values is presentation).
//
// Guards carried from the pivot column_total precedent:
//   - numeric values ONLY — non-numeric entries are skipped, never coerced;
//   - NEVER 0-filled — no numeric value in the scope returns null, which the
//     renderer shows as an em-dash, never a zero.

// The finite numbers of one column's values across a row scope. Booleans and
// numeric STRINGS are deliberately not numbers here: a "3" that looks numeric
// is host display data, not a countable value.
export function numericValues(values) {
  return (values || []).filter((value) => typeof value === "number" && Number.isFinite(value))
}

// Sum over the numeric values, or null when the scope has none.
export function sum(values) {
  const numbers = numericValues(values)
  if (numbers.length === 0) return null
  return numbers.reduce((total, value) => total + value, 0)
}

// Average over the numeric values, or null when the scope has none.
export function avg(values) {
  const numbers = numericValues(values)
  if (numbers.length === 0) return null
  return numbers.reduce((total, value) => total + value, 0) / numbers.length
}

// Dispatch by rollup function name. Unknown names yield null (the renderer's
// em-dash path) rather than throwing — a host typo degrades one cell, never
// the grid.
export function rollup(values, fn = "sum") {
  if (fn === "avg") return avg(values)
  if (fn === "sum") return sum(values)
  return null
}
